import { dateDayWeeksBefore } from 'utils/dates';

const strategyExecution2 = [
  { investor: 'I', date: dateDayWeeksBefore(5, 5), strategyExecution: 5 },
  { investor: 'J', date: dateDayWeeksBefore(5, 5), strategyExecution: 7 },
  { investor: 'L', date: dateDayWeeksBefore(5, 5), strategyExecution: 6 },
  { investor: 'M', date: dateDayWeeksBefore(5, 5), strategyExecution: 5 },
  { investor: 'N', date: dateDayWeeksBefore(4, 1), strategyExecution: 4 },
  { investor: 'O', date: dateDayWeeksBefore(4, 1), strategyExecution: 5 },
  { investor: 'P', date: dateDayWeeksBefore(4, 1), strategyExecution: 5 },
  { investor: 'Q', date: dateDayWeeksBefore(4, 5), strategyExecution: 7 },
  { investor: 'R', date: dateDayWeeksBefore(4, 5), strategyExecution: 5 },
  { investor: 'S', date: dateDayWeeksBefore(4, 5), strategyExecution: 5 },
  { investor: 'T', date: dateDayWeeksBefore(3, 1), strategyExecution: 6 },
  { investor: 'U', date: dateDayWeeksBefore(3, 1), strategyExecution: 5 },
  { investor: 'A', date: dateDayWeeksBefore(3, 2), strategyExecution: 6 },
  { investor: 'B', date: dateDayWeeksBefore(3, 2), strategyExecution: 6 },
  { investor: 'C', date: dateDayWeeksBefore(3, 2), strategyExecution: 7 },
  { investor: 'D', date: dateDayWeeksBefore(3, 2), strategyExecution: 6 },
  { investor: 'E', date: dateDayWeeksBefore(3, 5), strategyExecution: 4 },
  { investor: 'F', date: dateDayWeeksBefore(3, 5), strategyExecution: 6 },
  { investor: 'G', date: dateDayWeeksBefore(3, 5), strategyExecution: 7 },
  { investor: 'AA', date: dateDayWeeksBefore(3, 5), strategyExecution: 6 },
  { investor: 'BB', date: dateDayWeeksBefore(2, 2), strategyExecution: 7 },
  { investor: 'BA', date: dateDayWeeksBefore(2, 2), strategyExecution: 7 },
  { investor: 'BC', date: dateDayWeeksBefore(2, 2), strategyExecution: 6 },
  { investor: 'CD', date: dateDayWeeksBefore(2, 3), strategyExecution: 4 },
  { investor: 'EF', date: dateDayWeeksBefore(2, 3), strategyExecution: 6 },
  { investor: 'FG', date: dateDayWeeksBefore(2, 3), strategyExecution: 5 },
  { investor: 'FD', date: dateDayWeeksBefore(2, 5), strategyExecution: 6 },
  { investor: 'XD', date: dateDayWeeksBefore(2, 5), strategyExecution: 7 },
  { investor: 'EF', date: dateDayWeeksBefore(1, 3), strategyExecution: 7 },
  { investor: 'FV', date: dateDayWeeksBefore(1, 4), strategyExecution: 5 },
  { investor: 'GN', date: dateDayWeeksBefore(1, 5), strategyExecution: 6 },
  { investor: 'ZCX', date: dateDayWeeksBefore(0, 0), strategyExecution: 7 }
];

export default strategyExecution2
